import '@/assets/scss/v2/main.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// plugins
import './plugins/vee-validate'
import './plugins/vue-meta'
import './plugins/boostrap-vue'
import 'bootstrap/dist/js/bootstrap.js'

// core
import './core/vue/error-handler'

// mixins
import { userMixin } from '@/modules/user/mixins/user.mixin'
import '@/mixins/alert.mixin'

import { commonMixin } from '@/mixins/common.mixin'

Vue.mixin(userMixin)
Vue.mixin(commonMixin)


// styles
import './sass/style.scss'

// ------------- old ugly stuff

import '@/assets/css/all.css'
import '@/assets/css/solid.css'
import '@/assets/css/style.css'

import vSelect from 'vue-select'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import { date, currency, capitalize, datetime, empty, hour } from '@/utils/filters'

Vue.use(VueGoodTablePlugin)
Vue.component('v-select', vSelect)

//Set filters
Vue.filter('date', date)
Vue.filter('datetime', datetime)
Vue.filter('hour', hour)
Vue.filter('currency', currency)
Vue.filter('capitalize', capitalize)
Vue.filter('empty', empty)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mounted() {
    if (this.isTrainingEnv()) {
      const favicon = document.getElementById('favicon');          
      favicon.href = '/favicon-training.ico';          
    } 
  },
  render: (h) => h(App)
}).$mount('#app')
